<template>
  <v-container grid-list-md class="team-page">
    <div class="team-hero">
      <div class="team-hero__icon"><v-icon color="white" large>group</v-icon></div>
      <div>
        <h2 class="team-hero__title">Operadores e Perfis</h2>
        <p class="team-hero__subtitle">
          Crie perfis de acesso e vincule operadores da sua equipe. As mudanças
          no perfil refletem automaticamente em todos os operadores vinculados.
        </p>
      </div>
    </div>

    <profiles-panel @profiles-changed="reloadKey++" />
    <operators-panel :key="reloadKey" />
  </v-container>
</template>

<script>
export default {
  name: "Team",
  components: {
    ProfilesPanel: () => import("@/components/team/ProfilesPanel.vue"),
    OperatorsPanel: () => import("@/components/team/OperatorsPanel.vue"),
  },
  data() {
    return { reloadKey: 0 };
  },
};
</script>

<style scoped>
.team-page {
  max-width: 980px;
  margin: 0 auto;
}
.team-hero {
  display: flex;
  align-items: center;
  gap: 16px;
  background: linear-gradient(135deg, var(--primary-color, #1976d2), #0a3fb5);
  border-radius: 20px;
  padding: 22px 24px;
  color: #fff;
  box-shadow: 0 10px 28px rgba(13, 71, 161, 0.25);
  margin-bottom: 18px;
}
.team-hero__icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.team-hero__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
}
.team-hero__subtitle {
  margin: 4px 0 0;
  font-size: 13.5px;
  opacity: 0.9;
  line-height: 1.4;
}
</style>
